import { render, staticRenderFns } from "./BlockType13.vue?vue&type=template&id=3d63dfbb&"
import script from "./BlockType13.vue?vue&type=script&lang=ts&"
export * from "./BlockType13.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports